import "./ContactSection.css";
import { useState } from "react";
import axios from "axios";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaArrowUp,
} from "react-icons/fa";

function ContactSection() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const res = await axios.post(
        "http://localhost/api/ContactSection.php",
        form,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response:", res);
      console.log("Data:", res.data);

      alert(JSON.stringify(res.data));

      setForm({
        name: "",
        email: "",
        message: "",
      });
    } catch (err) {
      alert("Something went wrong.");
      console.log(err);
    }

    setLoading(false);
  };

  return (
    <section className="grownex-contact-section">
      <div className="grownex-contact-wrapper">

        <div className="grownex-contact-heading-row">
          <h1 className="grownex-contact-heading">
            Get in <span>/touch/.</span>
          </h1>
        </div>

        <div className="grownex-contact-content">

          <div className="grownex-contact-left">

            <div className="grownex-contact-description-column">
              <p className="grownex-contact-description">
                Reach out to discover how Grownex can support your digital goals and help elevate your brand to new heights.
              </p>
            </div>

            <div className="grownex-contact-address-column">

              <div className="grownex-info-block">
                <FaMapMarkerAlt className="grownex-contact-icon" />

                <div className="grownex-info-content">
                  <h4>Office</h4>
                  <p>
                    4th Floor, Workflo - Oyo, Bziness Sphere,
                    Jubilee Enclave, Madhapur,
                    Hyderabad, Telangana 500081
                  </p>
                </div>
              </div>

              <div className="grownex-info-block">
                <FaPhoneAlt className="grownex-contact-icon" />

                <div className="grownex-info-content">
                  <h4>Contact</h4>
                  <p>+91 6281981832</p>
                  <p>hello@grownex.in</p>
                </div>
              </div>

            </div>

          </div>

          <div className="grownex-contact-right">

            <form
              className="grownex-contact-form"
              onSubmit={handleSubmit}
            >

              <div className="grownex-input-group">
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
                <label>Your Name *</label>
              </div>

              <div className="grownex-input-group">
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
                <label>Your Email *</label>
              </div>

              <div className="grownex-input-group">
                <textarea
                  rows="6"
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  required
                ></textarea>
                <label>Your Message *</label>
              </div>

              <button
                type="submit"
                className="grownex-submit-btn"
                disabled={loading}
              >
                <span>
                  {loading ? "Sending..." : "Get in touch"}
                </span>

                <FaArrowUp className="grownex-arrow-icon" />
              </button>

              <p className="grownex-privacy-text">
                By submitting, you agree to our
                <a href="/"> Terms </a>
                and
                <a href="/"> Privacy Policy</a>.
              </p>

            </form>

          </div>

        </div>

      </div>
    </section>
  );
}

export default ContactSection;